import u from 'umbrellajs'
import { range } from 'rambda'
import { debounce } from 'rambdax'

const enhanceTopDeck = topDeck => {
  const inner = u('.top-deck-inner').first()
  const scrollWidth = document.body.clientWidth - 40

  // Enable Click for all cards with [click-url] set
  u('.card[data-click-url]').on('click', function(event){
    // Omniture Tracking
    const position = Array.from(inner.children).indexOf(this) + 1
    // @TODO: We should have a stricter/easier to understand api for calling this, something like:
    //
    // omniTrack('TOP_PICKS_CLICK', position)
    //
    // If we expose tracking based on a typed ENUM this way we can make it much easier to reason
    // and verify what we are even doing in the first place.
    sessionStorage.setItem('eVar9', position)

    // Exclude elements that have their own click events from using click-url
    if(['BUTTON', 'A'].includes(event.target.tagName)){ return false; }
    const href = u(this).data('click-url')
    window.location = href
  })

  // Mobile Scrolling Functionality
  const $left = u('.deck-left', topDeck)
  const $right = u('.deck-right', topDeck)

  const setScroll = offset => inner.scroll({left: offset, behaviour: 'smooth'})
  const adjustScroll = offset => () => setScroll(inner.scrollLeft + offset)
  const adjustLeft = adjustScroll((scrollWidth * -1))
  const adjustRight = adjustScroll(scrollWidth)

  // We will only bind when the elements are present
  if($left.length && $right.length){
    $left.handle('click', adjustLeft)
    $right.handle('click', adjustRight)
  }

  // Mobile Dots
  // @TODO: We should consider having a utility function for rendering dots possibly
  // as we are using them in other JS like recent-notices.
  const $dots = u('.pagination-dots', topDeck)
  if($dots.length){
    const dotCount = Math.ceil(inner.scrollWidth / scrollWidth)
    const $elements = u(range(0, dotCount))
          .map(i => `<button value="${i}" />`)
          .handle('click', e => {
            setScroll(parseInt(e.target.value, 10) * scrollWidth)
            $dots.find('.active').removeClass('active')
            u(e.target).addClass('active')
          })
    $dots.append($elements)
  }

  // Handle event for scrolling mobile scrolling
  const isLeftHidden = () => inner.scrollLeft <= 40
  const isRightHidden = () => inner.scrollLeft >= inner.scrollWidth - document.body.clientWidth
  let hideLeft = null
  let hideRight = null
  const handleInnerScroll = debounce(() => {
    if(hideLeft != isLeftHidden()){ hideLeft = isLeftHidden(); $left.toggleClass('hidden', hideLeft) }
    if(hideRight != isRightHidden()){ hideRight = isRightHidden(); $right.toggleClass('hidden', hideRight) }
    $dots.find('.active').removeClass('active')
    const dotPos = Math.ceil( inner.scrollLeft / scrollWidth )
    $dots.find(`:nth-child(${dotPos + 1})`).addClass('active')
  }, 25)
  inner.addEventListener('scroll', handleInnerScroll, {passive : true})
  setTimeout(handleInnerScroll, 1)

  // @TODO: Unload/Unbind here for these benfits:
  // - Hot reloading can work correctly
  // - window.unload - better page reloading from back navigation
  // - reload itself on page resize
  return () => {
    u(inner).off(handleInnerScroll)
    $left.off(adjustLeft)
    $right.off(adjustRight)
    $dots.find('*').remove()
  }
}

export default function Cards(){
  // Initialise all top decks in their own closure
  const unloads = u('.top-deck').nodes.map(enhanceTopDeck)
  window.addEventListener('unload', unloads[0])
}
